export default class PaymentWithCard {
  constructor($module) {
    this.$module = $module;
    const $addNewCard = document.querySelector(
      ".bc-button__add-card > .bc-button"
    );
    const $addNewCardContainer = document.querySelector(
      ".bc-payment__container"
    );
    const $buttonDelete = document.querySelectorAll(
      ".bc-card__payment__button > .bc-button"
    );

    $addNewCard.addEventListener("click", function (e) {
      e.preventDefault();
      showCardContainer();
    });

    function showCardContainer() {
      $addNewCardContainer.classList.toggle("active-container");
    }
    $buttonDelete.forEach(function (paymentCard) {
      paymentCard.addEventListener("click", function (e) {
        e.preventDefault();
        let cardPaymentElement =
          paymentCard.parentElement.parentElement.parentElement.parentElement;
        cardPaymentElement.remove();
      });
    });
  }
}
